import { Outlet } from "react-router-dom";
import QuestionsProvider from "src/context/QuestionsProvider";

const QuestionsLayout = () => {
  return (
    <QuestionsProvider>
      <Outlet />
    </QuestionsProvider>
  );
};

export default QuestionsLayout;
